/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var ApiErrorCode;
(function (ApiErrorCode) {
    ApiErrorCode["ERROR_CODE_NONE"] = "ErrorCodeNone";
    ApiErrorCode["ERROR_CODE_NOT_FOUND"] = "ErrorCodeNotFound";
    ApiErrorCode["ERROR_CODE_BAD_REQUEST"] = "ErrorCodeBadRequest";
    ApiErrorCode["ERROR_CODE_INVALID_DATA"] = "ErrorCodeInvalidData";
    ApiErrorCode["ERROR_CODE_PERMISSION_DENIED"] = "ErrorCodePermissionDenied";
    ApiErrorCode["ERROR_CODE_INTERNAL_ERROR"] = "ErrorCodeInternalError";
    ApiErrorCode["ERROR_CODE_UNAUTHORIZED"] = "ErrorCodeUnauthorized";
    ApiErrorCode["ERROR_CODE_BAD_PRECONDITION"] = "ErrorCodeBadPrecondition";
    ApiErrorCode["ERROR_CODE_SHOPIFY_APP_REQUIRED"] = "ErrorCodeShopifyAppRequired";
    ApiErrorCode["ERROR_CODE_TRIAL_EXPIRED"] = "ErrorCodeTrialExpired";
})(ApiErrorCode || (ApiErrorCode = {}));
export function ApiErrorCodeFromJSON(json) {
    return ApiErrorCodeFromJSONTyped(json, false);
}
export function ApiErrorCodeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ApiErrorCodeToJSON(value) {
    return value;
}
